module.exports = __webpack_public_path__ + "static/img/home5.91bfe79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home5.svg
// module id = dP71
// module chunks = 1